/**
 * Tenant ↔ Argus model brand assignment hook (Wave 3 §10.2 #2).
 *
 * Wraps `GET /api/v1/admin/platform/tenant-argus-model-assignments` so
 * the Tenant Detail Assignments tab can render the per-tenant matrix.
 *
 * Mutations (POST / DELETE) land in §10.2 #3 once the API endpoints
 * are added — today only PATCH (toggle enable/notes) is implemented.
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from './api-client';

export interface ArgusAssignmentRow {
  id: string;
  organizationId: string;
  organizationName: string;
  argusModelId: string;
  brandId: string;
  argusModelEngineId: string;
  engineRoleLabel: string | null;
  engineBaseLlmKey: string | null;
  engineProvenance: string | null;
  isEnabled: boolean;
  assignedAt: string;
  lastModifiedAt: string;
  sysadminNotes: string | null;
}

export interface ArgusAssignmentListResponse {
  items: ArgusAssignmentRow[];
  total: number;
}

export function useArgusAssignments(organizationId: string) {
  return useQuery<ArgusAssignmentListResponse, Error>({
    queryKey: ['platform-tenant-argus-assignments', organizationId],
    queryFn: () =>
      apiClient.get<ArgusAssignmentListResponse>(
        `/admin/platform/tenant-argus-model-assignments?organizationId=${organizationId}`,
      ),
    enabled: !!organizationId,
  });
}
